// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1UFBJ","title":"ClientReferral_title__1yX4z","itemText":"ClientReferral_itemText__328ej"};